import { useState } from "react";
import moment from "moment";
import "./index.css";

export default function barrarInferior() {
  // Los mensajes que quieres que roten en tu carrusel
  const contenidoBanner = (
    <>
      <span className="fw-bold text-info">
        Alcaldía del Municipio Páez - Estado Portuguesa, Venezuela
      </span>
    </>
  );

  return (
    <div className="banner-carrusel-fijo bg-dark text-white p-1 d-flex align-items-center shadow-lg">
      {/* Contenedor de la animación */}
      <div className="flex-grow-1 overflow-hidden">
        <div className="carrusel-track fs-5">
          {/* Renderizamos el contenido dos veces para crear el efecto infinito real */}
          <div className="d-flex gap-5 align-items-center">
            {contenidoBanner}
          </div>
          <div className="d-flex gap-5 align-items-center" aria-hidden="true">
            {contenidoBanner}
          </div>
          <div className="d-flex gap-5 align-items-center" aria-hidden="true">
            {contenidoBanner}
          </div>
          <div className="d-flex gap-5 align-items-center" aria-hidden="true">
            {contenidoBanner}
          </div>
        </div>
      </div>
    </div>
  );
}
